
import { Component, Inject } from '@angular/core';
import { NgxSliderModule, Options } from '@angular-slider/ngx-slider';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IUniverseSelection } from 'src/app/state/app.state';

interface IUniverse {
  include_public: boolean,
  include_private: boolean,
  min_mcap?: number,
  max_mcap?: number,
  search_type?:string,
  showCloseButton?:boolean
  company_type?:string
}

@Component({
  selector: 'app-universe-selector',
  standalone: true,
  imports: [
    NgxSliderModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    MatCheckboxModule,
    CommonModule,
    MatTooltipModule
  ], templateUrl: './universe-selector.component.html',
  styleUrl: './universe-selector.component.css'
})

export class UniverseSelectorComponent {
  isPublicCompany: boolean = false;
  isPrivateCompany: boolean = false;
  useMinCap: boolean = false;
  useMaxCap: boolean = false;
  showCloseButton: boolean = true;
  company_type:string|undefined = '';
  min_market_cap: number | null = null;
  max_market_cap: number | null = null;
  minCapInput: string | undefined = undefined;
  maxCapInput: string | undefined = undefined;
  search_type:string|undefined = '';
  constructor(
    private dialogRef: MatDialogRef<UniverseSelectorComponent>, @Inject(MAT_DIALOG_DATA) public data: IUniverse | undefined
  ) {

    if (data) {
      this.search_type=data.search_type
      this.min_market_cap = data.min_mcap!;
      this.max_market_cap = data.max_mcap!;
      this.isPrivateCompany = data.include_private;
      this.isPublicCompany = data.include_public;
      this.company_type! = data!.company_type!;
      this.minCapInput = this.formatCap(this.min_market_cap);
      this.maxCapInput = this.formatCap(this.max_market_cap);
      this.showCloseButton = data.showCloseButton ?? true;
      if (this.minCapInput!=null) {
        this.useMinCap = true;
      }
       if (this.maxCapInput!=null) {
        this.useMaxCap = true;
      }

    }
  }

  // Parsing input values
  parseCapValue(val: string | undefined) {
    if (!val) return null;
    const match = val!.toUpperCase().match(/^([\d.]+)\s*([MBT])$/);
    const num = parseFloat(match![1]);
    if (match![2] === 'B') return num * 1e9;
    if (match![2] === 'T') return num * 1e12;
    if (match![2] == 'M') return num * 1e6;
    return Number(val) // For Millions
  }

  // Format value as string with suffix
  formatCap(val: number | null) {
    if (val == null) {
      return;
    }
    if (val >= 1e12) {
      return `${(val / 1e12).toFixed(1)}T`;
    } else if (val >= 1e9) {
      return `${(val / 1e9).toFixed(1)}B`;
    } else {
      return `${Math.round(val / 1e6)}M`;
    }
  }

  resetToDefault() {
    this.useMinCap = false;
    this.useMaxCap = false;
    this.minCapInput = undefined;
    this.maxCapInput = undefined;
    this.isPublicCompany = false;
    this.isPrivateCompany = false;
    if (this.company_type === 'Public Company' || this.company_type === 'Public Investment Firm') {
      this.isPublicCompany = true;
    } else if (this.company_type === 'Private Company' || this.company_type === 'Private Investment Firm') {
      this.isPrivateCompany = true;
    }
  }

  showError: boolean = false;
  errorText: string = "";
  onConfirm() {
    if (!this.isPublicCompany && !this.isPrivateCompany) {
      this.showError = true;
      this.errorText = "Please select at least one company type (Public or Private).";
      return;
    }
    let min = null;
    let max = null;
    if (this.useMinCap) {
      const parsedMin = this.parseCapValue(this.minCapInput);
      if (parsedMin == null) {
        this.showError = true;
        this.errorText = 'Please enter a valid minimum market cap value.';
        return;
      }
      min = parsedMin;
    }

    if (this.useMaxCap) {
      const parsedMax = this.parseCapValue(this.maxCapInput);
      if (parsedMax == null) {
        this.showError = true;
        this.errorText = 'Please enter a valid maximum market cap value.';
        return;
      }
      max = parsedMax;
    }

    if (min != null && max != null && min > max) {
      this.showError = true;
      this.errorText = "Minimum market cap cannot be greater than maximum market cap."
      return;
    }

    this.dialogRef.close({
      min,
      max,
      isPublic: this.isPublicCompany,
      isPrivate: this.isPrivateCompany,
    });
  }

onClose() {
  this.dialogRef.close(); 
}


}
